module.exports = __webpack_public_path__ + "img/4.c6fad6be.jpg";